import React from 'react';
import { useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';

import { appointmentConsentsModalActions } from '../../../../../redux/healthboard/appointment-consent-modal';
import Icon from '../../../../Icon';
import styles from '../index.styl';

export function ConsentRenderView({
  id,
  accepted,
  fileUrl,
  currentConsent,
  name = '',
  version,
  consentType: { name: consentTypeTitle } = {},
  formatMessage,
  organizationName,
  serviceName,
  startTime,
  allConsents,
  consentVersionTitle,
  patientUserInfoId,
}) {
  const dispatch = useDispatch();
  const handleOpenConsent = () => {
    if (accepted && fileUrl) {
      window.open(fileUrl);
    } else {
      dispatch(
        appointmentConsentsModalActions.open({
          consent: currentConsent,
          organizationName,
          serviceName,
          startTime,
          allConsents,
          patientUserInfoId,
        }),
      );
    }
  };
  const signedTitle = formatMessage({ id: 'appointment.consent.signed' });
  const notSignedTitle = formatMessage({ id: 'appointment.consent.notSigned' });

  return (
    <div
      key={id}
      className={styles.visitConsentItem}
      onClick={() => handleOpenConsent()}
    >
      <Icon name="icon-document-black" size={32} className={styles.icon} />
      <div className={styles.consentInfoWrapper}>
        <div className={styles.consentTitle}>{name}</div>
        <div className={styles.consentSubtitleRow}>
          <div className={styles.consentSubTitle}>
            {`${consentTypeTitle}, ${consentVersionTitle} ${version}`}
          </div>
          <Icon
            name={accepted ? 'icon-signed-consent' : 'icon-noSigned-consent'}
            size={12}
            className={styles.icon}
          />
          <div className={styles.consentStatusTitle}>
            {accepted ? signedTitle : notSignedTitle}
          </div>
        </div>
      </div>
    </div>
  );
}

ConsentRenderView.propTypes = {
  id: PropTypes.number,
  accepted: PropTypes.bool,
  fileUrl: PropTypes.string,
  currentConsent: PropTypes.object,
  name: PropTypes.string,
  version: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  consentType: PropTypes.object,
  formatMessage: PropTypes.func,
  organizationName: PropTypes.string,
  serviceName: PropTypes.string,
  startTime: PropTypes.string,
  allConsents: PropTypes.array,
  consentVersionTitle: PropTypes.string,
  patientUserInfoId: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentRenderView/index.jsx